export default __webpack_public_path__ + "static/christian-1f9030479a09cd905daa4aea54307704.png";